import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/trend-down-01.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M1.29289 6.29289C1.68342 5.90237 2.31643 5.90237 2.70696 6.29289L7.5761 11.1611C7.78576 11.3707 7.90099 11.4857 7.99016 11.5614C7.99333 11.5641 7.99703 11.5659 7.99992 11.5683C8.00282 11.5659 8.00652 11.5641 8.00969 11.5614C8.09886 11.4857 8.21409 11.3707 8.42375 11.1611L11.1611 8.42375C11.3474 8.23743 11.5293 8.05483 11.6952 7.91399C11.8701 7.76555 12.092 7.60578 12.3818 7.51164C12.7332 7.39746 13.1084 7.38404 13.4657 7.46965L13.6181 7.51164L13.8232 7.59367C14.0159 7.68521 14.1735 7.80271 14.3046 7.91399C14.4705 8.05483 14.6525 8.23743 14.8388 8.42375L20.9999 14.5849V9.99992C20.9999 9.44764 21.4476 8.99992 21.9999 8.99992C22.5522 8.99992 22.9999 9.44764 22.9999 9.99992V16.9999C22.9999 17.5522 22.5522 17.9999 21.9999 17.9999H14.9999C14.4476 17.9999 13.9999 17.5522 13.9999 16.9999C13.9999 16.4476 14.4476 15.9999 14.9999 15.9999H19.5859L13.4238 9.83879C13.2141 9.62913 13.0989 9.5141 13.0097 9.4384C13.0063 9.43556 13.003 9.43311 12.9999 9.43059C12.9969 9.43311 12.9935 9.43556 12.9902 9.4384C12.901 9.5141 12.7858 9.62913 12.5761 9.83879L9.83879 12.5761C9.65247 12.7624 9.47051 12.945 9.30461 13.0859C9.12977 13.2343 8.9078 13.3941 8.61809 13.4882C8.2164 13.6187 7.78345 13.6187 7.38176 13.4882C7.09205 13.3941 6.87008 13.2343 6.69524 13.0859C6.52934 12.945 6.34738 12.7624 6.16106 12.5761L1.29289 7.70696C0.902369 7.31643 0.902369 6.68342 1.29289 6.29289Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as TrendDown01Icon };
